// extracted by mini-css-extract-plugin
module.exports = {"modal":"ActionsHistoryReviewProposalModal_modal__sgXco","footer":"ActionsHistoryReviewProposalModal_footer__1OATR"};